import React, { useEffect, useState } from "react";
import CustomInput from "../../components/CustomInput";
import Select from "../Select";
import {
  createSupplie,
  uploadSupplieFile,
  uploadSupplieImage,
} from "../../services/medicines";
import { IS_LOCAL_ENV } from "../../App";
import Notification from "../ui-elements/Notification";

const uamSelectOptions = [
  { text: "Miligramos (mg)", value: "1" },
  { text: "Gramos (g)", value: "2" },
  { text: "Microgramos (µg)", value: "3" },
  { text: "Mililitros (mL)", value: "4" },
  { text: "Centímetros cúbicos (cc)", value: "5" },
  { text: "Unidades internacionales (UI)", value: "6" },
  { text: "Porcentaje (%)", value: "7" },
  { text: "MiliEquivalentes (mEq)", value: "8" },
  { text: "Pipas (ppt)", value: "9" },
];

const presSelectOptions = [
  { text: "Tabletas (comprimidos)", value: "1" },
  { text: "Cápsulas", value: "2" },
  { text: "Polvos", value: "3" },
  { text: "Píldoras", value: "4" },
  { text: "Jarabes", value: "5" },
  { text: "Suspensiones", value: "6" },
  { text: "Soluciones", value: "7" },
  { text: "Gotas", value: "8" },
  { text: "Inyecciones", value: "9" },
  { text: "Cremas y ungüentos", value: "10" },
  { text: "Pomadas", value: "11" },
  { text: "Geles", value: "12" },
  { text: "Sprays", value: "13" },
  { text: "Inhaladores", value: "14" },
  { text: "Nebulizadores", value: "15" },
  { text: "Parche transdérmico", value: "16" },
  { text: "Supositorios", value: "17" },
  { text: "Implantes", value: "18" },
  { text: "Viales", value: "19" },
  { text: "Ampollas", value: "20" },
  { text: "Blíster", value: "21" },
  { text: "Frascos", value: "22" },
  { text: "Cajas", value: "23" },
];

const NewSupplieForm = ({ handleClose, addNewSupplie }) => {
  const [sName, setSName] = useState("");
  const [cName, setCName] = useState("");
  const [imgUrl, setImgUrl] = useState("");
  const [imgFile, setImgFile] = useState(null);
  const [pdfUrl, setPdfUrl] = useState("");
  const [pdfFile, setPdfFile] = useState(null);
  const [presentation, setPresentation] = useState("");
  const [quantity, setQuantity] = useState("");
  const [unit, setUnit] = useState("");
  const [validData, setValidData] = useState(false);
  const [uploading, setUploading] = useState(false);

  const handleFileChange = (e, type) => {
    const selectedFile = e.target.files[0]; // Obtén el primer archivo seleccionado
    if (selectedFile) {
      // Verifica si el archivo es un PDF
      if (selectedFile.type.startsWith("image/") && type == "image") {
        setImgFile(selectedFile);
      } else if (selectedFile.type === "application/pdf" && type == "pdf") {
        setPdfFile(selectedFile);
      } else {
        Notification({
          title: "Operación inválida",
          text: `Inserte un archivo válido`,
          type: "Error",
        });
      }
    }
  };

  useEffect(() => {
    //pdf es opcional
    if (
      sName != "" &&
      cName != "" &&
      imgFile != "" &&
      presentation != "" &&
      quantity != "" &&
      unit != ""
    ) {
      setValidData(true);
    } else {
      setValidData(false);
    }
  }, [sName, cName, imgFile, presentation, quantity, unit]);

  const handleSubmit = (e) => {
    e.preventDefault();
    setUploading(true);
    const uploadData = async () => {
      try {
        const supplyImgObj = await uploadSupplieImage({
          alt: "medicine",
          file: imgFile,
        });
        let supplyFileObj = {};
        if (pdfFile && pdfFile != "")
          supplyFileObj = await uploadSupplieFile({ file: pdfFile });

        let supplyProps = {
          sName: sName,
          cName: cName,
          presentation: presentation,
          quantity: quantity,
          supplyImage: supplyImgObj.id,
          unit: unit,
        };
        if (supplyFileObj.id) supplyProps.supplyFile = supplyFileObj.id;

        // Hacer el POST request con FormData
        const response = await createSupplie(supplyProps);
        addNewSupplie(response);
        IS_LOCAL_ENV && console.log(response);
        setUploading(false);
        Notification({
          title: "Operación completada",
          text: `Se agregó la medicina exitosamente`,
          type: "Success",
        });
        handleClose();
      } catch (err) {
        Notification({
          title: "Error",
          text: `Algo salió mal...`,
          type: "Error",
        });
        IS_LOCAL_ENV && console.error(err);
      }
    };
    uploadData();
  };

  return (
    <>
      <div className="flex flex-col justify-start items-center gap-x-2  w-full">
        <h3 className="text-center text-xl font-bold font-poppins mb-4">
          Agregar Medicamento
        </h3>
        <form className="flex flex-col items-center w-full">
          <CustomInput
            placeholder="Fertilizante"
            value={sName}
            inputType="text"
            required={true}
            onChange={(e) => setSName(e.target.value)}
            title={"Nombre científico"}
            // w="w-[450px]"
          />
          <CustomInput
            title="Nombre del cliente"
            placeholder="Mon Roy"
            value={cName}
            inputType="text"
            required={true}
            onChange={(e) => setCName(e.target.value)}
          />
          <div className="my-2 w-full px-4">
            <span className="font-poppins font-bold">
              Selecciona una imagen: *
            </span>
            <input
              className="font-poppins rounded-full text-nowrap border-accent-green border-[1px] flex flex-col w-full text-sm"
              type="file"
              accept="image/*"
              onChange={(e) => handleFileChange(e, "image")}
            />
          </div>
          <div className="my-2 w-full px-4">
            <span className="font-poppins font-bold">
              Selecciona un archivo PDF:
            </span>
            <input
              className="font-poppins rounded-full text-nowrap border-accent-green border-[1px] flex flex-col w-full text-sm"
              type="file"
              accept="application/pdf"
              onChange={(e) => handleFileChange(e, "pdf")}
            />
          </div>
          <div className="flex flex-wrap w-full justify-between px-4">
            <div className="my-2 w-full">
              <span className="font-poppins font-bold">Presentación:*</span>
              <Select
                customW="w-full"
                options={presSelectOptions}
                isTableSelect={true}
                value={presentation}
                setValue={(e) => setPresentation(parseInt(e.target.value))}
              />
            </div>
            <div className="my-2 w-full mb-4">
              <span className="font-poppins font-bold">Unidad y medida:*</span>
              <Select
                customW="w-full"
                options={uamSelectOptions}
                isTableSelect={true}
                value={unit}
                setValue={(e) => setUnit(parseInt(e.target.value))}
              />
            </div>
          </div>

          <CustomInput
            title="Cantidad:"
            placeholder="500"
            value={quantity}
            required={true}
            inputType="number"
            onChange={(e) => setQuantity(parseInt(e.target.value))}
          />

          <div className="flex flex-row justify-center gap-x-4">
            {validData && (
              <button
                className={` w-fit  text-base m-4 mr-0 rounded-full py-2 px-4 text-white  transition-all duration-100 font-bold font-poppins ${
                  uploading
                    ? "bg-light-gray cursor-not-allowed"
                    : "hover:bg-accent-green bg-dark-green"
                }`}
                disabled={uploading}
                type="submit"
                onClick={handleSubmit}
              >
                <div className="flex flex-row items-center">
                  <span className="text-nowrap">Guardar</span>
                </div>
              </button>
            )}
            <button
              className={` w-fit bg-red-600 text-base m-4 ml-0 rounded-full py-2 px-4 text-white hover:bg-red-200 transition-all duration-100 font-bold font-poppins `}
              onClick={handleClose}
            >
              <div className="flex flex-row items-center">
                <span className="text-nowrap">Cancelar</span>
              </div>
            </button>
          </div>
        </form>
      </div>
    </>
  );
};

export default NewSupplieForm;
